import { render, staticRenderFns } from "./ProvisioningOptions.vue?vue&type=template&id=0b23b895&scoped=true&"
import script from "./ProvisioningOptions.vue?vue&type=script&lang=js&"
export * from "./ProvisioningOptions.vue?vue&type=script&lang=js&"
import style0 from "./ProvisioningOptions.vue?vue&type=style&index=0&id=0b23b895&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23b895",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSelect,VTooltip})
